// extracted by mini-css-extract-plugin
export default {"cell":"SharedGridTableCell_cell__Ff3ii"};